import {
  parseResultFolderName,
  RESULT_LOG_FOLDER,
  type TransientResultFolder,
  type TransientResultIteration,
  type TransientResultScenario,
} from "./formatJobResults";

export type GroupedJobResults = {
  logFolder: null | TransientResultFolder;
  scenarios: TransientResultScenario[];
};

export const groupResultScenarios = (folders: TransientResultFolder[]): GroupedJobResults => {
  const logFolder = folders.find((folder) => folder.folderName === RESULT_LOG_FOLDER) ?? null;
  const byScenario = new Map<string, TransientResultIteration[]>();
  folders.forEach((folder) => {
    if (folder.folderName === RESULT_LOG_FOLDER) return;
    const label = parseResultFolderName(folder.folderName);
    const iterations = byScenario.get(label.title) ?? [];
    iterations.push({
      files: folder.files,
      folderName: folder.folderName,
      iteration: label.iteration ?? 1,
    });
    byScenario.set(label.title, iterations);
  });
  const scenarios = [...byScenario.entries()]
    .map(([name, iterations]) => ({
      iterations: iterations.sort((a, b) => a.iteration - b.iteration),
      name,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
  return { logFolder, scenarios };
};
